import { PolicyholderType } from "platform-client/types/policyholders"

export const clientMap: Record<PolicyholderType, string> = {
  NotSet: "",
  Individual: "Individual",
  Business: "Business"
}
